import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaTelegramPlane, FaEnvelope } from "react-icons/fa";
import { colors, borderRadiusPx } from "../../../../theme";

const socialLinks = [
  {
    name: "Telegram",
    url: "https://t.me/+aouibOFxwW9hOTZlwa",
    icon: <FaTelegramPlane size={16} />,
    hoverColor: "#229ED9",
    hoverBg: "rgba(34, 158, 217, 0.15)",
  },
  {
    name: "Twitter / X",
    url: "https://twitter.com/AutobetLottery?t=eWnSpFjkAgkFmvNtIo67cg&s=09",
    icon: <FaTwitter size={16} />,
    hoverColor: "#1DA1F2",
    hoverBg: "rgba(29, 161, 242, 0.15)",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/autobet-lottery-ecosystem/",
    icon: <FaLinkedinIn size={16} />,
    hoverColor: "#0077B5",
    hoverBg: "rgba(0, 119, 181, 0.15)",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/Autobet-Lottery-529783064597758/?__tn__=C-R",
    icon: <FaFacebookF size={16} />,
    hoverColor: "#1877F2",
    hoverBg: "rgba(24, 119, 242, 0.15)",
  },
  {
    name: "Email Support",
    url: "mailto:info@autobetlottery.com",
    icon: <FaEnvelope size={15} />,
    hoverColor: colors.home.brandRed,
    hoverBg: colors.alpha.red[15],
  },
];

const FooterSocials = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Typography
        sx={{
          fontSize: "0.8rem",
          fontWeight: 600,
          color: colors.slate[300],
          textTransform: "uppercase",
          letterSpacing: "0.05em",
        }}
      >
        Join the Global Community
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flexWrap: "wrap" }}>
        {socialLinks.map((item) => (
          <Tooltip key={item.name} title={item.name} arrow placement="top">
            <Box
              component="a"
              href={item.url}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={item.name}
              className="autobet-footer-social-btn"
              sx={{
                borderRadius: borderRadiusPx.circle,
                backgroundColor: colors.alpha.white[5],
                border: `1px solid ${colors.sidebar.border}`,
                color: colors.slate[200],
                "&:hover": {
                  color: item.hoverColor,
                  backgroundColor: item.hoverBg,
                  borderColor: item.hoverColor,
                  boxShadow: `0 4px 12px ${item.hoverBg}`,
                },
              }}
            >
              {item.icon}
            </Box>
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
};

export default FooterSocials;
